import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { matchPath, useLocation } from 'react-router-dom'
import { ROUTES } from '@shared/config/routes'

const ROUTE_TO_KEY: Record<string, string> = {
  [ROUTES.LOGIN]: 'page_title.login',
  [ROUTES.REGISTER]: 'page_title.register',
  [ROUTES.RESET_PASSWORD]: 'page_title.reset_password',

  [ROUTES.ADMIN]: 'page_title.dashboard',
  [ROUTES.ADMIN_USERS]: 'page_title.users',
  [ROUTES.ADMIN_OLYMPIADS]: 'page_title.olympiads',
  [ROUTES.ADMIN_TASKS]: 'page_title.tasks',
  [ROUTES.ADMIN_RESULTS]: 'page_title.results',
  [ROUTES.ADMIN_RESULTS_OVERALL]: 'page_title.results_overall',
  [ROUTES.ADMIN_RESULTS_COUNTRIES]: 'page_title.results_countries',
  [ROUTES.ADMIN_CHAT]: 'page_title.chat',
  [ROUTES.ADMIN_PAYMENTS]: 'page_title.payments',
  [ROUTES.ADMIN_CERTIFICATES]: 'page_title.certificates',
  [ROUTES.ADMIN_PROFILE]: 'page_title.profile',
  [ROUTES.ADMIN_SETTINGS]: 'page_title.settings',

  [ROUTES.PARTICIPANT_DASHBOARD]: 'page_title.dashboard',
  [ROUTES.PARTICIPANT_OLYMPIADS]: 'page_title.olympiads',
  [ROUTES.PARTICIPANT_TASKS]: 'page_title.tasks',
  [ROUTES.PARTICIPANT_TASK_DETAIL]: 'page_title.task',
  [ROUTES.PARTICIPANT_RESULTS]: 'page_title.results',
  [ROUTES.PARTICIPANT_MY_WAY]: 'page_title.my_way',
  [ROUTES.PARTICIPANT_RATE_OLYMPIAD]: 'page_title.rate_olympiad',
  [ROUTES.PARTICIPANT_RATE_OVERALL]: 'page_title.results_overall',
  [ROUTES.PARTICIPANT_PAYMENTS]: 'page_title.payments',
  [ROUTES.PARTICIPANT_CERTIFICATES]: 'page_title.certificates',
  [ROUTES.PARTICIPANT_INSTRUCTIONS]: 'page_title.instructions',
  [ROUTES.PARTICIPANT_FAQ]: 'page_title.faq',
  [ROUTES.PARTICIPANT_PERSONAL]: 'page_title.personal',
  [ROUTES.PARTICIPANT_SETTINGS]: 'page_title.settings',

  [ROUTES.REPRESENTATIVE]: 'page_title.dashboard',
  [ROUTES.REPRESENTATIVE_MEMBERS]: 'page_title.members',
  [ROUTES.REPRESENTATIVE_MEMBER]: 'page_title.member_card',
  [ROUTES.REPRESENTATIVE_CHAT]: 'page_title.chat',
  [ROUTES.REPRESENTATIVE_RESULTS]: 'page_title.results',
  [ROUTES.REPRESENTATIVE_RESULTS_RATE]: 'page_title.team_rate',
  [ROUTES.REPRESENTATIVE_PROFILE]: 'page_title.profile',
  [ROUTES.REPRESENTATIVE_SETTINGS]: 'page_title.settings',
}

const PATTERNS = Object.entries(ROUTE_TO_KEY)

export function usePageTitle() {
  const { pathname } = useLocation()
  const { t, i18n } = useTranslation('common')

  useEffect(() => {
    const match = PATTERNS.find(([pattern]) => matchPath({ path: pattern, end: true }, pathname))
    document.title = match ? `${t(match[1])}${t('page_title.suffix')}` : t('page_title.default')
  }, [pathname, t, i18n.language])
}
